var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtraSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 5,
    viewBox: "0 0 23 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92857 2.50068C4.92857 3.88101 3.82527 5 2.46429 5C1.1033 5 0 3.88101 0 2.50068C0 1.12034 1.1033 0.0013504 2.46429 0.0013504C3.82527 0.0013504 4.92857 1.12034 4.92857 2.50068Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.964 2.50068C13.964 3.88101 12.8607 5 11.4997 5C10.1388 5 9.03545 3.88101 9.03545 2.50068C9.03545 1.12034 10.1388 0.0013504 11.4997 0.0013504C12.8607 0.0013504 13.964 1.12034 13.964 2.50068Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 2.49932C23 3.87966 21.8967 4.99865 20.5357 4.99865C19.1747 4.99865 18.0714 3.87966 18.0714 2.49932C18.0714 1.11899 19.1747 0 20.5357 0C21.8967 0 23 1.11899 23 2.49932Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraSidebarIcon);
export default __webpack_public_path__ + "static/media/extra-sidebar-icon.d644ab4d7078ba3c9f66e69f2f54798e.svg";
export { ForwardRef as ReactComponent };